<script>
export default {
  name: 'MaOnlyContentLayout',
  data() {
    return {
      id: 'container',
    }
  },
}
</script>

<template>
  <div class="ma-body-wrapper">
    <div :id="id" class="effect">
      <router-view />
    </div>
  </div>
</template>
